"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyDrillsForInsightWidgetHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var insight_1 = require("../../events/insight");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var widgetValidations_1 = require("./validation/widgetValidations");
var insightDrillDefinitionValidation_1 = require("./validation/insightDrillDefinitionValidation");
var layout_1 = require("../../store/layout");
var redux_batched_actions_1 = require("redux-batched-actions");
var insights_1 = require("../../store/insights");
var insightDrillDefinitionUtils_1 = require("./validation/insightDrillDefinitionUtils");
var validateDrillToCustomUrlParams_1 = require("../common/validateDrillToCustomUrlParams");
var validateDrills_1 = require("../common/validateDrills");
function modifyDrillsForInsightWidgetHandler(ctx, cmd) {
    var _a, drillsToModify, correlationId, widgets, insightWidget, widgetRef, validationData, _b, currentInsightDrills, validatedDrillDefinition, addedDrillDefinition, updatedDrillDefinition, drills, updatedInsightDrills, updatedWidget;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = cmd.payload.drills, drillsToModify = _a === void 0 ? [] : _a, correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _c.sent();
                insightWidget = widgetValidations_1.validateExistingInsightWidget(widgets, cmd, ctx);
                widgetRef = insightWidget.ref;
                return [4 /*yield*/, effects_1.call(insightDrillDefinitionValidation_1.getValidationData, widgetRef, drillsToModify, ctx)];
            case 2:
                validationData = _c.sent();
                _b = insightWidget.drills, currentInsightDrills = _b === void 0 ? [] : _b;
                validatedDrillDefinition = drillsToModify.map(function (drillItem) {
                    return insightDrillDefinitionValidation_1.validateDrillDefinition(drillItem, validationData, ctx, cmd);
                });
                addedDrillDefinition = validatedDrillDefinition.filter(function (drillItem) { return !insightDrillDefinitionUtils_1.existsDrillDefinitionInArray(drillItem, currentInsightDrills); });
                updatedDrillDefinition = validatedDrillDefinition.filter(function (drillItem) {
                    return insightDrillDefinitionUtils_1.existsDrillDefinitionInArray(drillItem, currentInsightDrills);
                });
                drills = currentInsightDrills.map(function (drillItem) {
                    var updated = insightDrillDefinitionUtils_1.getDrillDefinitionFromArray(drillItem, updatedDrillDefinition);
                    if (updated) {
                        return updated;
                    }
                    return drillItem;
                });
                updatedInsightDrills = tslib_1.__spread(drills, addedDrillDefinition);
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([
                        insights_1.insightsActions.addInsights(validationData.resolvedInsights.loaded),
                        layout_1.layoutActions.replaceWidgetDrills({
                            ref: insightWidget.ref,
                            drillDefinitions: updatedInsightDrills,
                            undo: {
                                cmd: cmd,
                            },
                        }),
                    ]))];
            case 3:
                _c.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetByRef(insightWidget.ref))];
            case 4:
                updatedWidget = _c.sent();
                return [4 /*yield*/, effects_1.call(validateDrills_1.validateDrills, ctx, cmd, [updatedWidget])];
            case 5:
                _c.sent();
                return [4 /*yield*/, effects_1.call(validateDrillToCustomUrlParams_1.validateDrillToCustomUrlParams, [updatedWidget])];
            case 6:
                _c.sent();
                return [2 /*return*/, insight_1.insightWidgetDrillsModified(ctx, widgetRef, addedDrillDefinition, updatedDrillDefinition, correlationId)];
        }
    });
}
exports.modifyDrillsForInsightWidgetHandler = modifyDrillsForInsightWidgetHandler;
//# sourceMappingURL=modifyDrillsForInsightWidgetHandler.js.map